import { addEdgeToDecisionTreePath } from 'actions/searchActions';
import {
  CLEAR_ACCOUNT_SEARCH,
  GLADLY_ACCOUNT_STATUS,
  SET_ACCOUNTS,
  SET_SELECTED_ACCOUNT,
  SET_SELECTED_PURCHASE,
  SET_ACCOUNT_REINSTATE_INFO,
} from 'constants/accountSearch';
import isEmpty from 'lodash/isEmpty';
import { SELECT_CUSTOMER_TO_REINSTATE_ACCOUNT_EDGES as EDGES } from 'constants/decisionTree';
import makeRequest from '../../../api/makeRequest';
import { handleError } from '../../../services/ErrorService/ErrorService';
import environment from 'environment';

const { ACCOUNT_BASE_URL } = environment.accountData;

const setAccounts = (accounts) => ({
  type: SET_ACCOUNTS,
  accounts,
});

export const clearAccountSearch = () => ({
  type: CLEAR_ACCOUNT_SEARCH,
});

export const setSelectedAccount = (account) => ({
  type: SET_SELECTED_ACCOUNT,
  account,
});

export const setSelectedPurchase = (purchase) => ({
  type: SET_SELECTED_PURCHASE,
  purchase,
});

export const setAccountReinstateInfo = (reinstateReason, canReinstateAccount, extraParams = {}) => ({
  type: SET_ACCOUNT_REINSTATE_INFO,
  reinstateReason,
  canReinstateAccount,
  extraParams,
});

export const checkAccountReinstateAndAddDTEdge = (accountId, simplrAccountId) => async (dispatch) => {
  try {
    const {
      canReinstateAccount,
      reason,
      extraParams = {},
    } = await makeRequest(`${ACCOUNT_BASE_URL}/${accountId}/canReinstateAccount`, {
      params: { simplrAccountId },
    });

    dispatch(setAccountReinstateInfo(reason, canReinstateAccount, extraParams));

    let edge;

    switch (reason.toLowerCase()) {
      case GLADLY_ACCOUNT_STATUS.SUSPENSION_IN_DETENTION.toLowerCase():
      case GLADLY_ACCOUNT_STATUS.SUSPENSION_FORCED_PASSWORD_RESET.toLowerCase():
      case GLADLY_ACCOUNT_STATUS.SUSPENSION_FORCED_PASSWORD_RESET_BASE_URL.toLowerCase():
        edge = canReinstateAccount ? EDGES.ACCOUNT_VALID_FOR_REINSTATEMENT : EDGES.CANNOT_BE_REINSTATED;
        break;
      default:
        edge = EDGES.NOT_IN_DETENTION;
    }

    return dispatch(addEdgeToDecisionTreePath(edge));
  } catch (error) {
    return dispatch(addEdgeToDecisionTreePath(EDGES.NO_CUSTOMER_OR_ACCOUNT_FOUND));
  }
};

export const lookupAndSetAccounts = (accountId, simplrAccountId) => async (dispatch) => {
  try {
    dispatch(clearAccountSearch());
    // for now we receive only one account, but we keep it in an array in case in the future we need to refactor to support multiple accounts.
    const { account } = await makeRequest(`${ACCOUNT_BASE_URL}/${accountId}`, { params: { simplrAccountId } });
    if (!isEmpty(account)) {
      dispatch(setAccounts([account]));
      dispatch(setSelectedAccount(account));
    }
  } catch (error) {
    handleError({
      error,
      customMessage: 'Something went wrong when searching for accounts.',
      customFields: { ACCOUNT_BASE_URL, accountId, simplrAccountId },
      showPopup: true,
    });
  }
};
